import { Icon } from '@/components/atoms/Icon';
import { Banner } from '../styled';
/**
 * @deprecated use src/components/molecules/TopNavBanner
 */
export function MotServiceBundleBanner() {
  return (
    <Banner className="mot-service">
      <Icon id="finance/tag-01-flipped" legacy={false} />
      <div>50% off your MOT with a Full Service</div>
    </Banner>
  );
}
